// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.AttributeTable {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
}

div.attribtable-overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(200, 200, 200);
    z-index: 4;
}

div.attribtable-overlay > div.spinner {
    width: 4em;
    height: 4em;
    margin-right: 1em;
}

div.attribtable-toolbar {
    display: flex;
    align-items: center;
    margin-bottom: 0.125em;
}

div.attribtable-toolbar > * {
    margin: 0.125em;
}

div.attribtable-contents {
    flex: 1 1 auto;
    height: 0;
    background-color: var(--list-bg-color);
    border: 1px solid var(--border-color);
    position: relative;
}

table.attribtable-table td > input:not([type=checkbox]),
table.attribtable-table td > select,
table.attribtable-table td > div.TextInput,
table.attribtable-table td > div.number-input,
table.attribtable-table td > div.edit-multi-select,
table.attribtable-table td > span.edit-upload-field,
table.attribtable-table td > span.edit-upload-field-input {
    min-width: 100%;
    width: 0;
    border: none!important;
    background-color: transparent!important;
    margin: 0;
    height: 100%;
}

table.attribtable-table td > div.TextInput,
table.attribtable-table td > div.TextInput > pre {
    min-height: 2em;
}

table.attribtable-table tr.row-disabled td > *:disabled,
table.attribtable-table tr.row-disabled,
table.attribtable-table tr.row-disabled * {
    color: var(--text-color-disabled);
    cursor: not-allowed!important;
}

div.attribtable-footbar {
    display: flex;
    align-items: center;
    margin: 0 -0.25em;
    flex-wrap: wrap;
}

div.attribtable-footbar > div {
    margin: 0.25em;
}

div.attribtable-filter {
    flex: 1 1 auto;
}

div.attribtable-filter .attribtable-filter-value {
    flex: 1 1 auto;
    min-width: 5em;
    max-width: 15em;
}
`, "",{"version":3,"sources":["webpack://./components/style/AttributeTableWidget.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,sCAAsC;IACtC,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;;;;;;;IAOI,eAAe;IACf,QAAQ;IACR,sBAAsB;IACtB,uCAAuC;IACvC,SAAS;IACT,YAAY;AAChB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;;IAGI,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;AACnB","sourcesContent":["div.AttributeTable {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    position: relative;\n}\n\ndiv.attribtable-overlay {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(200, 200, 200);\n    z-index: 4;\n}\n\ndiv.attribtable-overlay > div.spinner {\n    width: 4em;\n    height: 4em;\n    margin-right: 1em;\n}\n\ndiv.attribtable-toolbar {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0.125em;\n}\n\ndiv.attribtable-toolbar > * {\n    margin: 0.125em;\n}\n\ndiv.attribtable-contents {\n    flex: 1 1 auto;\n    height: 0;\n    background-color: var(--list-bg-color);\n    border: 1px solid var(--border-color);\n    position: relative;\n}\n\ntable.attribtable-table td > input:not([type=checkbox]),\ntable.attribtable-table td > select,\ntable.attribtable-table td > div.TextInput,\ntable.attribtable-table td > div.number-input,\ntable.attribtable-table td > div.edit-multi-select,\ntable.attribtable-table td > span.edit-upload-field,\ntable.attribtable-table td > span.edit-upload-field-input {\n    min-width: 100%;\n    width: 0;\n    border: none!important;\n    background-color: transparent!important;\n    margin: 0;\n    height: 100%;\n}\n\ntable.attribtable-table td > div.TextInput,\ntable.attribtable-table td > div.TextInput > pre {\n    min-height: 2em;\n}\n\ntable.attribtable-table tr.row-disabled td > *:disabled,\ntable.attribtable-table tr.row-disabled,\ntable.attribtable-table tr.row-disabled * {\n    color: var(--text-color-disabled);\n    cursor: not-allowed!important;\n}\n\ndiv.attribtable-footbar {\n    display: flex;\n    align-items: center;\n    margin: 0 -0.25em;\n    flex-wrap: wrap;\n}\n\ndiv.attribtable-footbar > div {\n    margin: 0.25em;\n}\n\ndiv.attribtable-filter {\n    flex: 1 1 auto;\n}\n\ndiv.attribtable-filter .attribtable-filter-value {\n    flex: 1 1 auto;\n    min-width: 5em;\n    max-width: 15em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
